/* product.js — variant selection without dependencies */
(function () {
  'use strict';
  var form = document.getElementById('ProductForm');
  if (!form) return;
  var selects = form.querySelectorAll('[data-product-select]');
  var idInput = form.querySelector('[data-variant-id-input]');
  if (!selects.length || !idInput) return;

  function currentOptions() {
    return Array.prototype.map.call(selects, function (s) { return s.value; });
  }

  selects.forEach(function (s) {
    s.addEventListener('change', function () {
      var chosen = currentOptions().join(' / ');
      var match = Array.prototype.find.call(idInput.options, function (o) {
        return o.textContent.trim().indexOf(chosen) === 0;
      });
      if (match) {
        idInput.value = match.value;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
})();
